import moment from "moment/moment";
import { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import { Link } from "react-router-dom";
import Select from "react-select";

import { useGetPageQuery, useLazyGetPageQuery } from "../../../redux/services/crmAPI";
import "../reportsOrder/reportsOrder.scss";

const ReportsRepairs = () => {
    const [fromDate, setFromDate] = useState(new Date());
    const [startDateSearchValue, setStartDateSearchValue] = useState("");
    const [toDate, setToDate] = useState(new Date());
    const [endDateSearchValue, setEndDateSearchValue] = useState("");

    const [selectMastersList, setSelectMastersList] = useState([]);
    const [selectCategoriesList, setSelectCategoriesList] = useState([]);

    const [master, setMaster] = useState([]);
    const [category, setCategory] = useState([]);

    const startDateParams = "&start_date=" + startDateSearchValue;
    const endDateParams = "&end_date=" + endDateSearchValue;
    const masterParams = master.join("");
    const categoryParams = category.join("");

    const paramsCombainer = startDateParams + endDateParams;

    const { data: masters } = useGetPageQuery("users?per_page=9999&active=1");
    const { data: categorySelect } = useGetPageQuery("categories/select");
    const [triggerRepairsReportFetch, result] = useLazyGetPageQuery();

    const onMasterSelectHandler = (selected) => {
        setMaster([...(selected || []).map((master) => "&master_ids[]=" + master.value)]);
    };

    const onCategorySelectHandler = (selected) => {
        setCategory([...(selected || []).map((category) => "&category_ids[]=" + category.value)]);
    };

    useEffect(() => {
        setStartDateSearchValue(moment(fromDate).format("DD.MM.YYYY"));
        setEndDateSearchValue(moment(toDate).format("DD.MM.YYYY"));
    }, [fromDate, toDate]);

    useEffect(() => {
        if (masters) {
            setSelectMastersList([
                ...masters.data
                    .filter((master) => master.user_permission_type_id === 2)
                    .map((master) => {
                        return { value: master.id, label: master.name };
                    }),
            ]);
        }

        if (categorySelect) {
            setSelectCategoriesList([
                ...categorySelect.map((category) => {
                    return {
                        value: category.id,
                        label: "\u00A0\u00A0\u00A0\u00A0\u00A0".repeat(category.level) + category.title,
                    };
                }),
            ]);
        }
    }, [masters, categorySelect]);

    const fetchReportsHandler = async () => {
        await triggerRepairsReportFetch("report/repairs?" + paramsCombainer + masterParams + categoryParams);
    };

    const calculateTotalPrice = (reports) => {
        return reports.reduce((totalPrice, repair) => totalPrice + (+repair.price || 0), 0);
    };

    const reports = result.data;

    return (
        <>
            {masters && categorySelect && (
                <div className="content">
                    <div className="col-12">
                        <div
                            id="page-header"
                            className="no-print"
                        >
                            <h1>Звіт по ремонтах</h1>
                        </div>
                        <div className="no-print">
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-6">
                                    <div className="card card-default">
                                        <div className="card-header">Виберіть фільтри</div>
                                        <div className="card-body">
                                            <div className="mt-3">
                                                <label className="d-block">Майстри</label>
                                                <Select
                                                    options={selectMastersList}
                                                    placeholder={"Майстер"}
                                                    isMulti
                                                    onChange={onMasterSelectHandler}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <label className="d-block">Категорії</label>
                                                <Select
                                                    options={selectCategoriesList}
                                                    placeholder={"Категорія"}
                                                    isMulti
                                                    onChange={onCategorySelectHandler}
                                                />
                                            </div>
                                            <button
                                                value="Створити звіт"
                                                className="btn btn-primary"
                                                style={{ marginTop: "12px" }}
                                                onClick={() => fetchReportsHandler()}
                                            >
                                                {result.isFetching ? "Завантаження" : "Створити звіт"}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-6">
                                    <div className="card card-default">
                                        <div className="card-header">Виберіть дату</div>
                                        <div className="card-body datas">
                                            <div className="input-group">
                                                <span
                                                    className="input-group-prepend"
                                                    id="date_from"
                                                >
                                                    <span className="input-group-text">Від</span>
                                                </span>
                                                <DatePicker
                                                    onChange={setFromDate}
                                                    value={fromDate}
                                                    format="dd.MM.yyyy"
                                                    locale="uk-UA"
                                                    className="custom-input"
                                                />
                                            </div>
                                            <div className="input-group">
                                                {" "}
                                                <span
                                                    className="input-group-prepend"
                                                    id="date_to"
                                                >
                                                    <span className="input-group-text">До</span>
                                                </span>
                                                <DatePicker
                                                    onChange={setToDate}
                                                    value={toDate}
                                                    format="dd.MM.yyyy"
                                                    locale="uk-UA"
                                                    className="custom-input"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>

                        {reports && (
                            <div className="row">
                                <div className="col-12">
                                    <div className="card card-default">
                                        <div className="card-header">
                                            Ремонти з {startDateSearchValue} по {endDateSearchValue}
                                        </div>
                                        <div className="card-body">
                                            {reports.length === 0 ? (
                                                <div className="alert alert-warning margin20">Ремонти відсутні</div>
                                            ) : (
                                                <div className="table-responsive">
                                                    <table className="table table-striped table-print">
                                                        <thead>
                                                            <tr>
                                                                <th data-field="id">ID</th>
                                                                <th data-field="device">Пристрій</th>
                                                                <th
                                                                    data-field="damage"
                                                                    className="no-mobile"
                                                                >
                                                                    Несправність
                                                                </th>
                                                                <th data-field="client">Клієнт</th>
                                                                <th
                                                                    data-field="master"
                                                                    className="no-mobile"
                                                                >
                                                                    Майстер
                                                                </th>
                                                                <th
                                                                    data-field="store"
                                                                    className="no-mobile"
                                                                >
                                                                    Магазин
                                                                </th>
                                                                <th
                                                                    data-field="status"
                                                                    className="no-mobile"
                                                                >
                                                                    Статус
                                                                </th>
                                                                <th data-field="price">Ціна</th>
                                                                <th
                                                                    data-field="date"
                                                                    className="no-mobile"
                                                                >
                                                                    Дата
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {reports.map((repair) => {
                                                                return (
                                                                    <tr key={repair.id}>
                                                                        <td>
                                                                            {repair.id ? (
                                                                                <Link to={"/repair/" + repair.id}>
                                                                                    Ремонт&nbsp;#{repair.id}
                                                                                </Link>
                                                                            ) : (
                                                                                <div>Ремонт&nbsp;#{repair.id}</div>
                                                                            )}

                                                                            <div>
                                                                                {repair.is_warranty ? (
                                                                                    <span className="badge bg-danger badge-model">
                                                                                        Гарантійний
                                                                                    </span>
                                                                                ) : null}
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            {repair.device_type ? (
                                                                                <div className="text-muted">
                                                                                    {repair.device_type}
                                                                                </div>
                                                                            ) : null}
                                                                            <div>{repair.device}</div>
                                                                            {repair.imei ? (
                                                                                <div className="text-muted">
                                                                                    IMEI/SN: {repair.imei}
                                                                                </div>
                                                                            ) : null}
                                                                        </td>
                                                                        <td className="no-mobile">{repair.damage}</td>
                                                                        <td>
                                                                            {repair.client_name}
                                                                            <br />
                                                                            {repair.client_phone}
                                                                        </td>
                                                                        <td className="no-mobile">
                                                                            {repair.user?.name}
                                                                        </td>
                                                                        <td className="no-mobile">
                                                                            {repair.store?.title}
                                                                        </td>
                                                                        <td className="no-mobile">
                                                                            {repair.status?.title}
                                                                        </td>
                                                                        <td>{repair.price}&nbsp;грн.</td>
                                                                        <td className="no-mobile">
                                                                            {moment(repair.created_at).format(
                                                                                "DD.MM.YYYY HH:mm",
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            <div className="all_price_of_day">
                                                Кількість: <b>{reports.length}</b>
                                            </div>
                                            <div className="all_price_of_day red">
                                                Всього: <b>{calculateTotalPrice(reports)}&nbsp;грн.</b>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="no-print">
                                        <button
                                            className="btn btn-primary pull-right no-print"
                                            value="Друк"
                                            onClick={() => window.print()}
                                        >
                                            Друк звіту
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ReportsRepairs;
